
jQuery(function initResortScrollingHelpers($) {

    $('.resort-detail-container').each(function(index, el) {

        var initializeHelpers = function() {

            $('.js-policies').click(function() {

                $('html, body').animate({
                    scrollTop: $('.resort-policies-container').offset().top
                }, 300);
            });

            $('.js-all-inclusive-information').click(function() {

                $('html, body').animate({
                    scrollTop: $('.resort-all-inclusive-information-container').offset().top
                }, 300);
            });

            $('.js-applicable-fees').click(function() {

                $('html, body').animate({
                    scrollTop: $('.resort-applicable-fees-container').offset().top
                }, 300);
            });
        };

        initializeHelpers();
    });
});